// import { Storage } from '@/infra/Storage';
import { API_BASE_URL, apiRequest } from '../config/api';

// const API_BASE_URL = 'https://grammar-backend-production.up.railway.app/api';

const getHeaders = (includeAuth = true) => {
  const headers = {
    'Content-Type': 'application/json'
  };
  
  if (includeAuth) {
    headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
  }
  
  return headers;
};

// Test Session APIs
export const testSessionAPI = {
  getSession: async (id) => {
    return apiRequest(`/test-sessions/${id}`);
  },

  submitSession: async (id, answers) => {
    return apiRequest(`/test-sessions/${id}/submit`, {
      method: 'POST',
      body: JSON.stringify({ userAnswers: answers })
    });
  },

  getActiveSessions: async () => {
    return apiRequest(`/test-sessions?status=active`);
  },

  startNewSession: async (config) => {
    return apiRequest(`/test-sessions/start`, {
      method: 'POST',
      body: JSON.stringify({
        testType: config.testType,
        topic: config.topic,
        questionCount: config.questionCount,
        grade: config.grade
      })
    });
  }
};

// Results APIs
export const resultsAPI = {
  getResult: async (id) => {
    return apiRequest(`/results/${id}`);
  },

  getMyResults: async () => {
    return apiRequest(`/results/my-results`);
  }
};

// User APIs
export const userAPI = {
  updateProfile: async (data) => {
    return apiRequest(`/users/profile`, {
      method: 'PATCH',
      body: JSON.stringify(data)
    });
  }
};

export const aiTutorAPI = {
  getResponse: async (data) => {
    return apiRequest(`/ai/tutor`, {
      method: 'POST',
      body: JSON.stringify(data)
    });
  }
};

// Writing Session APIs
export const writingAPI = {
  getSessionsHistory: async () => {
    return apiRequest(`/writing/sessions/history`);
  },

  getActiveSessions: async () => {
    return apiRequest(`/writing/sessions?status=active`);
  },

  startNewSession: async (config, grade) => {
    return apiRequest(`/writing/sessions/start`, {
      method: 'POST',
      body: JSON.stringify({
        ...config,
        grade: grade
      })
    });
  },

  submitSession: async (sessionId, content) => {
    return apiRequest(`/writing/sessions/${sessionId}/submit`, {
      method: 'POST',
      body: JSON.stringify({ userAnswers: content })
    });
  },

  getSession: async (sessionId) => {
    return apiRequest(`/writing/sessions/${sessionId}`);
  },

  getCreativeTopics: async (grade = 4) => {
    try {
      return apiRequest(`/writing/creative/topics?grade=${grade}`);
    } catch (error) {
      throw new Error('Failed to fetch creative topics');
    }
  },

  startCreativeSession: async (config) => {
    try {
      return apiRequest(`/writing/creative/start`, {
        method: 'POST',
        body: JSON.stringify(config)
      });
    } catch (error) {
      throw new Error('Failed to start creative session');
    }
  },

  getPersuasiveTopics: async (grade = 4) => {
    try {
      return apiRequest(`/writing/persuasive/topics?grade=${grade}`);
    } catch (error) {
      throw new Error('Failed to fetch persuasive topics');
    }
  },

  startPersuasiveSession: async (data) => {
    try {
      return apiRequest(`/writing/persuasive/start`, {
        method: 'POST',
        body: JSON.stringify(data)
      });
    } catch (error) {
      throw new Error('Failed to start persuasive session');
    }
  },

  submitCreativePersuasiveSession: async (sessionId, userAnswer) => {
    try {
      return apiRequest(`/writing/sessions/${sessionId}/submit-creative-persuasive`, {
        method: 'POST',
        body: JSON.stringify({ userAnswer })
      });
    } catch (error) {
      throw new Error('Failed to submit writing session');
    }
  },
};

// Writing Results APIs
export const writingResultsAPI = {
  getResult: async (id) => {
    return apiRequest(`/writing/results/${id}`);
  },

  getUserResults: async () => {
    return apiRequest(`/writing/results`);
  }
}; 